<template>
    <div></div>
</template>

<script>
    import {ebus} from '../vendor/ebus';
    import {notificationUtil} from './notificationUtil'


    export default {
        name: "Notification",
        created() {
            ebus.$on('pojsNotify', (p) => {
                notificationUtil.pojsNotification(p.title, p.text, p.image, p.icon);
            });
            ebus.$on('inAppNotify', (params) => {
                this.inAppNotify();
            });
            ebus.$on('dingDnng5x', () => {
                for (let i = 0; i < 10; i += 2) {
                    setTimeout(() => {
                        this.inAppNotify();
                    }, 1 + (i * 1000));
                }
            });
        },
        methods: {
            inAppNotify() {
                notificationUtil.inAppNotifySound();
            },
        }
    }
</script>

<style scoped>

</style>